"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = exports.NotificationResponse = exports.Notification = void 0;
var Notification = /** @class */ (function () {
    function Notification() {
        this.id = '';
        this.applicationResponseId = '';
        this.userId = '';
        this.type = NotificationType.General;
        this.title = '';
        this.message = '';
        this.metadata = {};
        this.createdDate = new Date();
    }
    return Notification;
}());
exports.Notification = Notification;
var NotificationResponse = /** @class */ (function () {
    function NotificationResponse() {
        this.notifications = [];
        this.totalCount = 0;
        this.unreadCount = 0;
        this.hasMore = false;
    }
    return NotificationResponse;
}());
exports.NotificationResponse = NotificationResponse;
var NotificationType;
(function (NotificationType) {
    NotificationType["General"] = "General";
    NotificationType["ScheduledChargeChange"] = "ScheduledChargeChange";
    NotificationType["PlaidIDVerification"] = "PlaidIDVerification";
    NotificationType["PlaidIncomeVerification"] = "PlaidIncomeVerification";
    NotificationType["ApplicationCompletion"] = "ApplicationCompletion";
    NotificationType["SpecialValidationFailed"] = "SpecialValidationFailed";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
